import React, { useState, useEffect } from 'react';
import { setCookie, getCookie, cookieExists, deleteCookie } from "../../Script/cookies.js";
import ContactMailIcon from '@mui/icons-material/ContactMail';
import SwitchAccountOutlinedIcon from '@mui/icons-material/SwitchAccountOutlined';
import { ismitglied, post } from '../../Script/Session.js';
import { Token } from '../../Script/Session.js';
import { useNavigate } from 'react-router-dom';
import "./Navigationbar.css";
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined';
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import AlignHorizontalRightOutlinedIcon from '@mui/icons-material/AlignHorizontalRightOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined';
import MyLocationOutlinedIcon from '@mui/icons-material/MyLocationOutlined';
import MapsHomeWorkOutlinedIcon from '@mui/icons-material/MapsHomeWorkOutlined';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import PsychologyAltOutlinedIcon from '@mui/icons-material/PsychologyAltOutlined';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';
import AlignVerticalBottomOutlinedIcon from '@mui/icons-material/AlignVerticalBottomOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import FormatIndentIncreaseIcon from '@mui/icons-material/FormatIndentIncrease';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import GpsFixedOutlinedIcon from '@mui/icons-material/GpsFixedOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
const NavigationBar = ({ state, back }) => {
    const navigate = useNavigate();
    const [widthvar, setwith] = useState(state === "adminhome" ? "13%" : "10%");
    const [widthsubvar, setsubwith] = useState("100%");
    const [textaktiv, settextaktiv] = useState("inline");
    const [m, setm] = useState("55px");

    useEffect(() => {

    }, []);

    const mouseenter = () => {
        if (state === "adminhome") {
            setwith("13%");

        } else {
            setwith("10%");

        }
        setm("55px");
        setsubwith("100%");
        setTimeout(() => {
            settextaktiv("inline");
        }, 200);
    }
    const mouseleave = () => {


    }
    function haspermission(permission) {
        let body = {};
        body.token = Token.get();
        body.permission = permission;
        let response = post(body, "/SinglePermissionRequest")
        if (response == null) {
            return false;
        } else if (response == "OK.") {
            return true;
        } else if (response == "NOPERMISSION") {
            navigate("/")
        } else if (response == "NOPERMS") {
            navigate("/");
        }
        return false;
    }
    function clickVerwaltung() {
        if (haspermission("1")) {
            navigate("/verwaltung-nutzer-anlegen");
        } else {
            alert("Keine Berechtigung!");
        }

    }

    function backfn() {
        if (state == "adminhome" || state == "verein" || state == "vergleiche" || state == "profile") {
            navigate("/home");
            return;
        }
        window.history.back();
    }



    return (
        <div onMouseEnter={mouseenter} onMouseLeave={mouseleave} style={{ width: widthvar }} className='navigationbar-outlinediv'>
            <div style={{ width: widthsubvar, marginLeft: m, }} className='navigationbar-headicon'>
                <PlaceOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></PlaceOutlinedIcon>
                <label className='navigation-bar-text' style={{ display: textaktiv }}>Navigation</label>
            </div>
            <div className='navigationbar-line-placeholder'></div>

            {
                back != false && (
                    <div onClick={backfn} style={{ width: widthsubvar, display: back, marginLeft: m, }} title='Zurück' id='zurückiconnavigationbar' className='navigationbar-line-object'>
                        <KeyboardReturnOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></KeyboardReturnOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Zurück</label>
                    </div>
                )
            }
            {state === "profile" && (
                <>
                    <div onClick={() => {

                        navigate("/my-profile/--")

                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Profil' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <PersonIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></PersonIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Mein Profil</label>
                    </div>
                    <div onClick={() => {

                        navigate("/my-betriebe")

                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Betriebe' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <Groups2OutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></Groups2OutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Mein Betriebe</label>
                    </div>
                    <div onClick={() => {

                        navigate("/betriebsliste")

                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Betriebe' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <PeopleIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></PeopleIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Betriebe</label>
                    </div>
                    <div onClick={() => {

                        navigate("/organisation")

                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Regionalgruppen' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <SupervisedUserCircleIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></SupervisedUserCircleIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Organisation</label>
                    </div>
                    <div onClick={() => {

                        navigate("/regionalgruppen_view")

                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Regionalgruppen' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <SupervisedUserCircleIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></SupervisedUserCircleIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>R-Gruppen</label>
                    </div>
                </>


            )}
            {state === "vergleiche" && (
                <>
                    <div onClick={() => {

                        navigate("/vergleich-home")

                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Vergleiche' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <AlignVerticalBottomOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></AlignVerticalBottomOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Vergleichen</label>
                    </div>
                    <div onClick={() => {

                        navigate("/vergleichsKathegorien")

                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Sparten' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <BackupTableOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></BackupTableOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Sparten</label>
                    </div>
                    <div onClick={() => {
                        navigate("/listview/konzept")
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Konzepte' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <FormatIndentIncreaseIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></FormatIndentIncreaseIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Konzepte</label>
                    </div>
                    <div onClick={() => {
                        navigate("/listview/empfehlung")
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='E,p' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <FormatIndentIncreaseIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></FormatIndentIncreaseIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Empfehlungen</label>
                    </div>


                    <div onClick={() => {
                        navigate("/gesellschaften")
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Allgemein' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <Diversity3OutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></Diversity3OutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Gesellschaften</label>
                    </div>

                </>
            )}


            {state === "verein" && (
                <>
                    <div onClick={() => {

                        navigate("/verein-allgemein")

                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Allgemein' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <InfoOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></InfoOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Allgemein</label>
                    </div>
                    <div onClick={() => {

                        navigate("/userlist")

                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Allgemein' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <PeopleOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></PeopleOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Mitglieder/Nutzer</label>
                    </div>
                    <div onClick={() => {
                        navigate("/verein-datein")
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Vereinsdatein' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <DriveFileMoveOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></DriveFileMoveOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Vereinsdatein</label>
                    </div>
                    <div onClick={() => {
                        navigate("/verein-nutzerdatein")
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Vereins NutzerDatein' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <DriveFileMoveOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></DriveFileMoveOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>NutzerDatein</label>
                    </div>
                    <div onClick={() => {
                        navigate("/f-beschreibungen")
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Vereins Funktionen Beschreibungen' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <PsychologyAltOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></PsychologyAltOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>F-Beschreibung</label>
                    </div>
                    <div onClick={() => {
                        navigate("/beschlussbuch")
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Beschlussbuch' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <MenuBookOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></MenuBookOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Beschlussbuch</label>
                    </div>
                </>
            )}

            {state === "adminhome" && (

                <>
                    <div onClick={() => {
                        if (haspermission("2")) {
                            navigate("/verwaltung-nutzer-anlegen")
                        } else {
                            alert("Keine Berechtigung!");
                        }
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Neue Nutzer Anlegen' id='newnutzericonnavigationbar' className='navigationbar-line-object'>
                        <AddCircleOutlineOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></AddCircleOutlineOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Neuer Nutzer</label>
                    </div>
                    <div onClick={() => {
                        if (haspermission("3")) {
                            navigate("/verwaltung-nutzer-verwalten");
                        } else {
                            alert("Keine Berechtigung!");
                            return;
                        }



                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Nutzer Verwalten' id='nutzerverwalteniconnavigationbar' className='navigationbar-line-object'>
                        <ContactPageOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></ContactPageOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Nutzer Verwalten</label>
                    </div>
                    <div onClick={() => {
                        if (haspermission("4")) {
                            navigate("/verwaltung-gruppen-verwalten");
                        } else {
                            alert("Keine Berechtigung!");
                            return;
                        }
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Funktionen' id='berechtigungiconnavigationbar' className='navigationbar-line-object'>
                        <AlignHorizontalRightOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></AlignHorizontalRightOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Funktionen</label>
                    </div>
                    <div onClick={() => {
                        if (haspermission("5")) {
                            navigate("/verwaltung-event-verwalten");
                        } else {
                            alert("Keine Berechtigung!");
                            return;
                        }
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Punkte' id='pointsiconnavigationbar' className='navigationbar-line-object'>
                        <MyLocationOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></MyLocationOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Punkte</label>
                    </div>
                    <div onClick={() => {

                        navigate("/regionalgruppen");

                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Punkte' id='pointsiconnavigationbar' className='navigationbar-line-object'>
                        <Diversity3OutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></Diversity3OutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Regionalgruppen</label>
                    </div>
                    <div onClick={() => {
                        navigate("/regionalgruppe_zuweisen");
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Nutzer Verwalten' id='nutzerverwalteniconnavigationbar' className='navigationbar-line-object'>
                        <ContactPageOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></ContactPageOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Regionalgruppe zuweisen</label>
                    </div>


                </>)}







            {state == "home" && (
                <>
                    <div onClick={() => navigate("/home")} style={{ width: widthsubvar, marginLeft: m, }} title='Startseite' id='forumiconnavigationbar' className='navigationbar-line-object'>
                        <AccountTreeOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></AccountTreeOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Start</label>
                    </div>
                    <div onClick={() => {
                        navigate("/foren");
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Forum' id='forumiconnavigationbar' className='navigationbar-line-object'>
                        <ForumOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></ForumOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Forum</label>
                    </div>
                    <div onClick={() =>
                        navigate("/vergleichsKathegorien")


                    } style={{ width: widthsubvar, marginLeft: m, }} title='Vergleiche' id='vergleichiconnavigationbar' className='navigationbar-line-object'>
                        <LocalLibraryOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></LocalLibraryOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Produkte</label>
                    </div>
                    <div style={{ width: widthsubvar, marginLeft: m, }} onClick={() => {

                        navigate("/verein-allgemein")


                    }} title='Vereine' id='vereiniconnavigationbar' className='navigationbar-line-object'>
                        <GroupsOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></GroupsOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Verein</label>
                    </div>

                    <div
                        onClick={() => {
                            navigate("/protokolle");
                        }} style={{ width: widthsubvar, marginLeft: m, }} title='Protokolle' id='a2hg' className='navigationbar-line-object'>
                        <FilePresentIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></FilePresentIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Protokolle</label>
                    </div>
                    <div
                        onClick={() => {
                            if (!ismitglied()) {
                                alert("Dafür musst du Mitglied sein");
                                return;
                            }
                            navigate("/downloads");
                        }}
                        style={{ width: widthsubvar, marginLeft: m, }} title='Downloads' id='gaskjkk' className='navigationbar-line-object'>
                        <CloudDownloadIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></CloudDownloadIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Downloads</label>
                    </div>


                    <div onClick={() => {
                        navigate("/aktivitäten");
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Veranstaltungen' id='regionaliconavbaraaa' className='navigationbar-line-object'>
                        <EventAvailableOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></EventAvailableOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Aktitäten</label>
                    </div>
                    <div onClick={() => {
                        navigate("/punktekonto");


                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Veranstaltungen' id='regionaliconavbaraaa' className='navigationbar-line-object'>
                        <GpsFixedOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></GpsFixedOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Punktekonto</label>
                    </div>

                    {/* room for more parts */}

                    <div style={{ width: widthsubvar, marginLeft: m, }} onClick={clickVerwaltung} title='Verwaltung || Administration' id='regionaliconavbar' className='navigationbar-line-object'>
                        <AdminPanelSettingsOutlinedIcon className='navigation-bar-icon' sx={{ fontSize: "1.5vw" }}></AdminPanelSettingsOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Verwaltung</label>
                    </div>
                    <div onClick={() => {
                        navigate("/my-profile/--")
                    }} style={{ width: widthsubvar, marginLeft: m, }} title='Profil' id='vergleichiconnavigationbar' className='navigationbar-line-object'>
                        <PermIdentityOutlinedIcon sx={{ fontSize: "1.5vw" }}></PermIdentityOutlinedIcon>
                        <label className='navigation-bar-text' style={{ display: textaktiv }}>Profil</label>
                    </div>

                </>
            )}






        </div>
    );


}
export default NavigationBar;